import { render, staticRenderFns } from "./position-form-page.vue?vue&type=template&id=22c5c36c&"
import script from "./position-form-page.vue?vue&type=script&lang=js&"
export * from "./position-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports